import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../../components/UI';
import './Login.css';

const Login = () => {
  const { connectWallet, error, loading } = useAuth();

  const handleConnect = async () => {
    await connectWallet();
  };

  if (loading) {
    return (
      <div className="login-page">
        <div className="login-container">
          <div className="loading-spinner" />
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>Samuel's 2026</h1>
          <p className="login-subtitle">Personal Planning System</p>
        </div>

        <div className="login-content">
          <div className="wallet-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" />
              <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />
            </svg>
          </div>

          <h2>Connect Your Wallet</h2>
          <p className="login-description">
            Sign a message with your Ethereum wallet to access this private planning system.
          </p>

          {error && (
            <div className="login-error">
              {error}
            </div>
          )}

          <Button 
            variant="gold" 
            onClick={handleConnect}
            className="connect-btn"
          >
            Connect with MetaMask
          </Button>

          <p className="login-note">
            Only authorized wallets can access this site.
          </p>
        </div>

        <div className="login-footer">
          <p>Powered by Ethereum</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
